import React, { memo } from "react";
import PropTypes from "prop-types";
import {
  FaExclamationTriangle,
  FaCheckDouble,
  FaClock,
  FaHourglassHalf,
} from "react-icons/fa";
import { Icon } from "@chakra-ui/react";
import {
  ERROR_STATUSES,
  PROCESSING_STATUSES,
  SCHEDULED_STATUSES,
  SUCCESS_STATUSES,
} from "../../../_constants/PostStatus";

const PostStatusIcon = ({ status, onClick, size, variant, ...rest }) => {
  if (SUCCESS_STATUSES.includes(status)) {
    return (
      <Icon as={FaCheckDouble} fontSize={size} color="blue.500" {...rest} />
    );
  }
  if (ERROR_STATUSES.includes(status)) {
    return (
      <Icon
        as={FaExclamationTriangle}
        fontSize={size}
        color="brand.negative"
        {...rest}
      />
    );
  }
  if (SCHEDULED_STATUSES.includes(status)) {
    return (
      <Icon
        as={FaClock}
        fontSize={size}
        color={variant === "dark" ? "brand.positive" : "brand.positive_darker"}
        {...rest}
      />
    );
  }
  if (PROCESSING_STATUSES.includes(status)) {
    return (
      <Icon
        as={FaHourglassHalf}
        fontSize={size}
        color={variant === "dark" ? "gray.100" : "gray.800"}
        {...rest}
      />
    );
  }

  return null;
};

PostStatusIcon.propTypes = {
  size: PropTypes.string,
  status: PropTypes.oneOf([
    ...SUCCESS_STATUSES,
    ...PROCESSING_STATUSES,
    ...ERROR_STATUSES,
    ...SCHEDULED_STATUSES,
  ]),
  variant: PropTypes.oneOf(["light", "dark"]),
};

PostStatusIcon.defaultProps = {
  size: "sm",
  status: undefined,
  variant: "dark",
};

export default memo(PostStatusIcon);
